// @flow

import Roarr from 'roarr';

const Logger = Roarr
  .child({
    program: 'global-agent',
  });

export default Logger;
